/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fond_Maple_Heron_LeapInputs */

const en_fond_maple_heron_leap = /** @type {(inputs: Fond_Maple_Heron_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const de_fond_maple_heron_leap = /** @type {(inputs: Fond_Maple_Heron_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Fond_Maple_Heron_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fond_maple_heron_leap = /** @type {((inputs?: Fond_Maple_Heron_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fond_Maple_Heron_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fond_maple_heron_leap(inputs)
	return de_fond_maple_heron_leap(inputs)
});